export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2ZM9.219 8.055a.75.75 0 1 0 0 1.5h4.202L8.239 14.66a.75.75 0 0 0 1.053 1.069l5.192-5.118v4.161a.75.75 0 1 0 1.5 0V8.805a.75.75 0 0 0-.75-.75H9.22Z"/>
</svg>`;
